import { Injectable } from "@angular/core";
import { Status } from "./models/status.model";

@Injectable()
export class TransactionBatchStatus{
  constructor(){}
  getListTransactionStatus():Status[]{
    let TransactionTypeList:Status[]=[];
    TransactionTypeList.push( new Status(0, 'Dừng'));
    TransactionTypeList.push( new Status(1, 'Mới'));
    TransactionTypeList.push( new Status(2, 'Đang xử lý'));
    TransactionTypeList.push( new Status(3, 'Hoàn tất'));
    return TransactionTypeList;
  }
}